import { ModalCustom } from "components/ModalCustom";
import { ContainerMensagem, Icone, ModalBody } from "./style";
import { FaCheck } from "react-icons/fa";

interface IProps {
  show: boolean;
  handleClose: () => void;
  numeroNfRecibo: string | number;
}

export function ModalSucessoEditarProcessos({
  show,
  handleClose,
  numeroNfRecibo,
}: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title={`Editar - Lote de pagamento ${numeroNfRecibo}`}
      centered={true}
      footer={false}
      footerConfirmButton={false}
    >
      <ModalBody>
        <Icone>
          <FaCheck />
        </Icone>
        <ContainerMensagem>Alterações salvas com sucesso!</ContainerMensagem>
      </ModalBody>
    </ModalCustom>
  );
}
